










import { EventBus } from '@/event-bus';
import Vue from 'vue';

interface Data {
  isMainVisible: boolean;
  isPageInternalNavVisible: boolean;
  isPageSidebarVisible: boolean;
  isGlobalFooterVisible: boolean;
  shouldDisplay: boolean;
}

export default Vue.extend({
  name: 'SkipLinks',
  mounted() {
    this.checkAvailableComponents();
    EventBus.$on('initialLoadDone', this.checkAvailableComponents);
    EventBus.$on('hideSkip', () => {
      this.shouldDisplay = false;
    });
    EventBus.$on('showSkip', () => {
      this.shouldDisplay = true;
    });
  },
  watch: {
    $route(to, from) {
      if (to.name !== from.name) {
        setTimeout(() => {
          if (this.$refs.skipLinks) {
            (this.$refs.skipLinks as any).focus();
          }
          this.checkAvailableComponents();
        }, 0);
      }
    },
  },
  data(): Data {
    return {
      isMainVisible: true,
      isPageInternalNavVisible: true,
      isPageSidebarVisible: true,
      isGlobalFooterVisible: true,
      shouldDisplay: true,
    };
  },
  methods: {
    checkAvailableComponents() {
      (this.isMainVisible = !!document.getElementById('main')),
        (this.isPageInternalNavVisible = !!document.getElementById(
          'page-internal-nav',
        )),
        (this.isPageSidebarVisible = !!document.getElementById('page-sidebar')),
        (this.isGlobalFooterVisible = !!document.getElementById('global-footer'));
    },
  },
});
